import { RegisterUserFormData } from '../types';
import { FormFieldValidationRuleSet } from '~/composables/useFormValidation/types';
import {
  ALWAYS_VALID_VALIDATOR_RULE,
  HAS_VALUE_VALIDATOR_RULE,
} from '~/composables/useFormValidation/rules';

export const MANDATORY_VALIDATORS: FormFieldValidationRuleSet<RegisterUserFormData> =
  {
    email: HAS_VALUE_VALIDATOR_RULE,
    firstname: HAS_VALUE_VALIDATOR_RULE,
    lastname: HAS_VALUE_VALIDATOR_RULE,
    country: {
      errorI18nKey: 'invalid country',
      name: 'country',
      test: (value: RegisterUserFormData['country']) =>
        value != null && value.length > 0,
    },
    password: [
      HAS_VALUE_VALIDATOR_RULE,
      {
        name: 'password-length',
        test: (value: RegisterUserFormData['password']) => value.length >= 6,
        errorI18nKey: 'register/form/password/hint',
      },
    ],
    passwordRepeat: [
      HAS_VALUE_VALIDATOR_RULE,
      {
        name: 'passwords-identical',
        test: (value: RegisterUserFormData['passwordRepeat'], formData) =>
          value === formData.password,
        errorI18nKey: 'register/form/password/repeat_hint',
        references: 'password',
      },
    ],
    postalCode: ALWAYS_VALID_VALIDATOR_RULE,
    locality: ALWAYS_VALID_VALIDATOR_RULE,
    street: ALWAYS_VALID_VALIDATOR_RULE,
    newsletter: ALWAYS_VALID_VALIDATOR_RULE,
  };

export const ZIPCODE_VALIDATORS: Pick<
  FormFieldValidationRuleSet<RegisterUserFormData>,
  'postalCode'
> = {
  postalCode: HAS_VALUE_VALIDATOR_RULE,
};

export const FULL_ADDRESS_VALIDATORS: Pick<
  FormFieldValidationRuleSet<RegisterUserFormData>,
  'street' | 'locality'
> = {
  street: HAS_VALUE_VALIDATOR_RULE,
  locality: HAS_VALUE_VALIDATOR_RULE,
};

export default {
  MANDATORY_VALIDATORS,
  ZIPCODE_VALIDATORS,
  FULL_ADDRESS_VALIDATORS,
};
